import script from "./PerformanceComponentAddOrEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceComponentAddOrEditModal.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceComponentAddOrEditModal.vue?vue&type=style&index=0&id=36a5a510&lang=css"

const __exports__ = script;

export default __exports__